module.exports = __webpack_public_path__ + "img/Rectangle 17.66c7575c.png";